const Microsoft = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='12.9231' y='12.923' width='9.23077' height='9.23077' fill='#FEBA08' />
      <rect x='1.84619' y='12.923' width='9.23077' height='9.23077' fill='#05A6F0' />
      <rect x='12.9231' y='1.84613' width='9.23077' height='9.23077' fill='#80BC06' />
      <rect x='1.84619' y='1.84613' width='9.23077' height='9.23077' fill='#F25325' />
    </svg>
  );
};

export default Microsoft;
